import { render } from "./FomoPhoneInput.vue?vue&type=template&id=7f980a92&scoped=true"
import script from "./FomoPhoneInput.vue?vue&type=script&lang=js"
export * from "./FomoPhoneInput.vue?vue&type=script&lang=js"

import "./FomoPhoneInput.vue?vue&type=style&index=0&id=7f980a92&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f980a92"]])

export default __exports__